import React, { useEffect, useState } from "react";
import { swalError } from "src/utils/sweetPopup";
import fetchRequest from "src/network";
import { isNotNull } from "src/utils/constants";
import MaintenanceBanner from "./MaintenanceBanner";
import { MaintenancePage } from "./MaintenancePage";

export default function MaintenanceGuard({ children }) {
    const [dismissed, setDismissed] = useState(false);
    const [status, setStatus] = useState(null); // "live" | "upcoming" | "none"
    const [timeRange, setTimeRange] = useState({ from: null, to: null });

    useEffect(() => {
        const getMaintenanceStatus = async () => {
            try {
                await fetchRequest?.get(`/setup/get-value/maintenance-status`)?.then((response) => {
                    console.log("Maintenance Guard RESPONSE", response);
                    if (response?.status_code === 200 && isNotNull(response?.data)) {
                        const now = new Date();
                        const from = new Date(response?.data.from);
                        const to = new Date(response?.data.to);

                        setTimeRange({ from, to });

                        if (now >= from && now <= to) {
                            setStatus("live");
                        } else if (now < from) {
                            setStatus("upcoming");
                        } else {
                            setStatus("none");
                        }
                    }
                })?.catch((error) => {
                    swalError(error);
                });
            } catch (error) {
                swalError(error);
            }
        }
        getMaintenanceStatus();
    }, []);

    // Maintenance is live — show the maintenance page overlay
    if (status === "live") {
        return <MaintenancePage to={timeRange.to} />;
    }

    // Maintenance is upcoming — show upcoming banner
    if (status === "upcoming" && !dismissed) {
        return (
            <div style={{ position: "relative" }}>
                <MaintenanceBanner
                    from={timeRange.from}
                    to={timeRange.to}
                    onDismiss={() => setDismissed(true)}
                />
                {children}
            </div>
        );
    }

    // Normal or maintenance ended — return app children
    return children;
}